import { User, UserPermissions } from '@centecomm/portal-service';
import BusinessNavigationIcon from 'Icons/NavigationItem/Business';
import React from 'react';
import useComplianceHubEnabled from 'utils/Hooks/LaunchDarkly/useComplianceHubEnabled';

import { FeatureConfiguration } from '../../Core/Types/FeatureConfiguration';
import { LoadingContent } from '../../Shared/PageElements/LoadingContent';
import { userIsTenant } from '../../utils/Users';

const LazyWelcome = React.lazy(() => import('./Welcome/Welcome'));
const LazyBusinessPage = React.lazy(() => import('./Pages/BusinessPage'));
const isComplianceHubEnabled = () => useComplianceHubEnabled();

const businessConfiguration: FeatureConfiguration = {
    name: 'Business',
    application: {
        url: '/app/welcome',
        PageRoot: (
            <React.Suspense fallback={<LoadingContent />}>
                <LazyWelcome />
            </React.Suspense>
        ),
        permissions: [UserPermissions.CompleteOccupantInitialSetup],
    },
    navigationItem: {
        route: {
            text: 'common:sidebar.featureBusinessTitle',
            url: '/business',
            Icon: BusinessNavigationIcon,
            ownerOperatorRoot: null,
            tenantRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyBusinessPage />
                </React.Suspense>
            ),
        },
        permissions: [],
        isAllowed: (user: User): boolean => userIsTenant(user),
    },
    disableFeature: [],
    checkIfEnabledViaSettings: () => !isComplianceHubEnabled(),
};

export default businessConfiguration;
